import { render, staticRenderFns } from "./direct-inbox.vue?vue&type=template&id=50a064d2&"
import script from "./direct-inbox.vue?vue&type=script&lang=js&"
export * from "./direct-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a064d2')) {
      api.createRecord('50a064d2', component.options)
    } else {
      api.reload('50a064d2', component.options)
    }
    module.hot.accept("./direct-inbox.vue?vue&type=template&id=50a064d2&", function () {
      api.rerender('50a064d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/direct-inbox.vue"
export default component.exports